import type { FC } from "react";

import { CmsHtml } from "~/shared/ui/CmsHtml";

import type { FooterV4Props } from "../FooterV4";

const HTML_TAG_PATTERN = /<[^>]*>/g;
const HTML_SPACE_ENTITY_PATTERN = /(?:&nbsp;|&#160;)/gi;

const normalizeVisibleHtmlText = (value: string): string => {
  return value
    .replace(HTML_TAG_PATTERN, " ")
    .replace(HTML_SPACE_ENTITY_PATTERN, " ")
    .replace(/\s+/g, " ")
    .trim();
};

const isDuplicateHtmlText = (left: string, right: string): boolean => {
  const leftText = normalizeVisibleHtmlText(left);
  return leftText.length > 0 && leftText === normalizeVisibleHtmlText(right);
};

export const FooterDescription: FC<FooterV4Props> = ({ data }) => {
  const licenses = data?.translations?.[0]?.licenses ?? "";
  const mobileDescription = data?.translations?.[0]?.mobile_description ?? "";
  const tabletDescription =
    data?.translations?.[0]?.tablet_description ?? mobileDescription;
  const desktopDescription =
    data?.translations?.[0]?.desktop_description ?? tabletDescription;

  const renderDescription = (description: string): string => {
    return isDuplicateHtmlText(licenses, description) ? "" : description;
  };

  return (
    <div className="w-full [&_a]:underline [&_a]:underline-offset-2">
      {licenses && <CmsHtml>{licenses}</CmsHtml>}
      <div className="block md:hidden">
        <CmsHtml>{renderDescription(mobileDescription)}</CmsHtml>
      </div>
      <div className="max-md:hidden md:block lg:hidden">
        <CmsHtml>{renderDescription(tabletDescription)}</CmsHtml>
      </div>
      <div className="hidden lg:block">
        <CmsHtml>{renderDescription(desktopDescription)}</CmsHtml>
      </div>
    </div>
  );
};
